import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Education from '../components/Education';
import Certificates from '../components/Certificates';
import ContactInfo from '../components/ContactInfo';
import usePageTitle from '../hooks/usePageTitle';

import { CONTACT_INFO } from '../data/resumeData';

import("../styles/resume.scss");

function Professional() {
  usePageTitle(CONTACT_INFO.name + " - " + CONTACT_INFO.title);
  
  return (
    <div id="Resume">
        <div className="header">
          <h1>{CONTACT_INFO.name}</h1>
          <div id="JobTitle">{CONTACT_INFO.title}</div>
          <ContactInfo />
        </div>
        <div className="stats">
          <Skills />
          <Certificates />
          <Education />
        </div>
        <div className="related">
          <About />
          <Experience />
        </div>
    </div>
  );
}

export default Professional;
